const formatDateToYMD = (dateString) => {
  if (!dateString || typeof dateString !== "string") return "";
  return dateString.slice(0, 10);
};

export default function TabReprint({ loading, reprintResult, handleReprintSearch, handleReprintDO, handleReprintInvoice }) {
  return (
    <div className="card">
      <h3>Re-print Documents</h3>
      <div className="grid grid-auto">
        <div className="field" style={{ gridColumn: "1 / -1" }}>
          <button type="button" onClick={handleReprintSearch} disabled={loading}>
            {loading ? "Searching..." : "Search AWB"}
          </button>
        </div>
      </div>

      {reprintResult && (
        <div style={{ marginTop: "1rem", borderTop: "1px solid #eee", paddingTop: "1rem", display: "flex", flexDirection: "column", gap: "1rem" }}>
          {(() => {
            const rawItems = Array.isArray(reprintResult) ? reprintResult : [reprintResult];
            
            // ✅ إزالة التكرار: الاحتفاظ بآخر سجل تم العثور عليه للبوليصة (يحل مشكلة ظهور 656 و 315 معاً)
            const uniqueItemsMap = new Map();
            rawItems.forEach(item => {
              if (item?.bol?.bol_reference) {
                uniqueItemsMap.set(item.bol.bol_reference, item);
              }
            });
            const items = Array.from(uniqueItemsMap.values());

            return items.map((item, idx) => {
              if (!item || !item.bol) return null;
              const { bol, header } = item;
              
              // ✅ التحقق المحسّن - يشمل billing_documents
              const hasReceipt = !!(
                bol.receipt_no ||
                bol.receipt_amount > 0 ||
                bol.bd_receipt_id || // من billing_documents
                bol.bd_receipt_amount > 0
              );
              
              const hasInvoice = !!(
                bol.d_no ||
                bol.dNo ||
                bol.invoice_amount > 0 ||
                bol.bd_invoice_id || // من billing_documents
                bol.bd_invoice_amount > 0 ||
                bol.is_delivered === 1  // لو مسلّم يعني فيه فاتورة
              );

              // ✅ تحديد المبالغ للعرض (الأولوية لـ billing_documents)
              const receiptAmount = bol.receipt_amount || bol.bd_receipt_amount || 0;
              const invoiceAmount = bol.bd_invoice_amount || bol.invoice_amount || 0;

              return (
                <div className="card" key={bol.id || idx}>
                  <h4 style={{ margin: "0 0 0.5rem 0" }}>AWB: {bol.bol_reference}</h4>
                  <div className="grid grid-auto small-gap" style={{ fontSize: "0.9rem" }}>
                    <div><strong>Flight No.:</strong> {bol.flight_no || header?.flight_no || bol.voyage_number || header?.voyage_number || "N/A"}</div>
                    <div><strong>Arrival:</strong> {header?.date_of_arrival ? String(header.date_of_arrival).slice(0, 10) : "N/A"}</div>
                    <div><strong>Consignee:</strong> {bol.consignee_name}</div>
                    <div>
                      <strong>Status:</strong>{" "}
                      {hasInvoice ? "Delivered ✅" : hasReceipt ? "DO Issued 📜" : "Pending ⏳"}
                    </div>
                    {bol.delivery_date && (
                      <div><strong>Delivery Date:</strong> {formatDateToYMD(bol.delivery_date)}</div>
                    )}
                    {hasReceipt && receiptAmount > 0 && (
                      <div><strong>Receipt Amount:</strong> ${Number(receiptAmount).toFixed(2)}</div>
                    )}
                    {hasInvoice && invoiceAmount > 0 && (
                      <div><strong>Invoice Amount:</strong> ${Number(invoiceAmount).toFixed(2)}</div>
                    )}
                  </div>

                  <div style={{ marginTop: "1rem", display: "flex", gap: "10px", borderTop: "1px solid #eee", paddingTop: "1rem" }}>
                    <button type="button" className="btn" onClick={() => handleReprintDO(item)}>
                      🧾 Re-print Receipt {receiptAmount > 0 ? `($${Number(receiptAmount).toFixed(2)})` : ''}
                    </button>
                    <button type="button" className="btn btn-primary" onClick={() => handleReprintInvoice(item)}>
                      📄 Re-print Invoice {invoiceAmount > 0 ? `($${Number(invoiceAmount).toFixed(2)})` : ''}
                    </button>
                  </div>
                </div>
              );
            });
          })()}
        </div>
      )}
    </div>
  );
}
